import { VideoSession } from 'pages/event/[eventId]/sessions/[sessionId]';

export const canDisplayVideoCutterPlayer = (
  videoSessions: VideoSession | null,
  posterId?: string,
) => {
  if (videoSessions && videoSessions.presentations) {
    const posterPresentation = videoSessions.presentations.find(
      presentation => presentation.presentation_id === posterId,
    );

    return (
      posterPresentation &&
      posterPresentation?.videos.length > 0 &&
      posterPresentation?.videos.some(video => video.is_assigned)
    );
  }
  return false;
};
